// extracted by mini-css-extract-plugin
export default {"container":"Monitor_container__pQnpP","rows":"Monitor_rows__G+LOT","boxes":"Monitor_boxes__LBb6X","attitude":"Monitor_attitude__jrcm7"};